export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";